export default "__VITE_ASSET__CafRLkLX__"